import React, { useEffect } from "react";
import { BrowserRouter as Router, Route, Routes, useLocation } from "react-router-dom";
import { I18nextProvider } from "react-i18next";
import { useContext } from "react";
import { ThemeContext } from "../../hooks/ThemeContext";
import Home from "../../pages/Home/index";
import Orders from "../../pages/Order";
import Contact from "../../pages/Contact";
import Footer from "../globals/Footer";
import Navbar from "../globals/Navbar";
import NotFound from "../globals/NotFound";
import i18n from "../languages/i18n";
import Register from "../../pages/Auth/Register";
import Login from "../../pages/Auth/Login";
import Dashboard from "../../pages/Admin";
import ProtectedRoute from "../globals/ProtectedRoute";
import ClientSpace from "../../pages/ClientSpace";
import Services from "../../pages/Services";
import Cart from "../../pages/Cart";
import Checkout from "../../pages/Checkout";
import PaymentSuccess from "../../pages/PaymentSuccess";
import PaymentCancel from "../../pages/PaymentCancel";
import Downloads from "../../pages/ClientSpace/Downloads";
import Pricing from "../../pages/Pricing";
import Payment from "../../pages/Payment";
import Legal from "../../pages/Legal";
import Portfolio from "../../pages/Portfolio";
import Monia from "../../pages/Monia";

// Composant pour changer la langue

const RouteContainer = () => {
  // Initialiser la langue Ã  partir du localStorage
  useEffect(() => {
    const savedLanguage = localStorage.getItem("language") || "fr"; // Langue par dÃ©faut
    i18n.changeLanguage(savedLanguage); // Applique la langue
  }, []);

  const { theme } = useContext(ThemeContext);

  const ScrollToTop = () => {
    const { pathname } = useLocation();

    useEffect(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [pathname]);

    return null;
  };

  return (
    <I18nextProvider i18n={i18n}>
      <Router>
        <ScrollToTop />
        <div className={`min-h-screen flex flex-col ${theme === 'dark' ? 'bg-[#0f1114] text-white' : 'bg-slate-50 text-gray-800'}`}>
          <Navbar />

          <main className="flex-1">
            <div className="root">
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/portfolio" element={<Portfolio />} />
                {/* Pages vitrine uniquement */}
                <Route path="/" element={<Home />} />
                <Route path="/services" element={<Services />} />
                <Route path="/tarifs" element={<Pricing />} />
                <Route path="/paiement" element={<Payment />} />
                <Route path="/mentions-legales" element={<Legal />} />
                <Route path="/contact" element={<Contact />} />
                {/* Admin et maintenance */}
                <Route path="/dashboard" element={<ProtectedRoute element={<Dashboard />} roleRequired={3} />} />
                <Route path="/monia" element={<ProtectedRoute element={<Monia />} allowedRoles={[3]} />} />
                {/* 404 */}
                <Route path="*" element={<NotFound />} />

                {/* Routes protÃ©gÃ©es - Utilisateurs connectÃ©s */}
                <Route
                  path="/cart"
                  element={
                    <ProtectedRoute element={<Cart />} allowedRoles={[1, 3]} />
                  }
                />
                <Route
                  path="/panier"
                  element={
                    <ProtectedRoute element={<Cart />} allowedRoles={[1, 3]} />
                  }
                />
                <Route
                  path="/checkout"
                  element={
                    <ProtectedRoute element={<Checkout />} allowedRoles={[1, 3]} />
                  }
                />
                <Route
                  path="/payment/success"
                  element={
                    <ProtectedRoute element={<PaymentSuccess />} allowedRoles={[1, 3]} />
                  }
                />
                <Route
                  path="/payment/cancel"
                  element={
                    <ProtectedRoute element={<PaymentCancel />} allowedRoles={[1, 3]} />
                  }
                />
                <Route
                  path="/orders"
                  element={
                    <ProtectedRoute element={<Orders />} allowedRoles={[1, 3]} />
                  }
                />
                <Route
                  path="/espace-client"
                  element={
                    <ProtectedRoute element={<ClientSpace />} allowedRoles={[1, 3]} />
                  }
                />
                <Route
                  path="/espaces-clients"
                  element={
                    <ProtectedRoute element={<ClientSpace />} allowedRoles={[1, 3]} />
                  }
                />
                <Route
                  path="/client-space"
                  element={
                    <ProtectedRoute element={<ClientSpace />} allowedRoles={[1, 3]} />
                  }
                />
                <Route
                  path="/mes-telechargements"
                  element={
                    <ProtectedRoute element={<Downloads />} allowedRoles={[1, 3]} />
                  }
                />
                <Route
                  path="/downloads"
                  element={
                    <ProtectedRoute element={<Downloads />} allowedRoles={[1, 3]} />
                  }
                />
                
                {/* Route Admin uniquement */}
                <Route
                  path="/monia"
                  element={
                    <ProtectedRoute element={<Monia />} allowedRoles={[3]} />
                  }
                />
                
                {/* Route 404 - doit Ãªtre en dernier */}
                <Route path="/404" element={<NotFound />} />
                <Route path="*" element={<NotFound />} />
              </Routes>
            </div>
          </main>

          <Footer />
        </div>
      </Router>
    </I18nextProvider>
  );
};

export default RouteContainer;

